import { ErrorInfo } from 'react';
import { sendLog } from '../api/requests/misc.api';
import { capitalizeFirstLetter } from './utilsFunctions';

export enum LogApplicationDeploi {
	SCREENING_PORTAL = 'Deploi: Screening Portal',
	CANDIDATE_PORTAL = 'Deploi: Candidate Portal',
    DEPLOI_API = 'Deploi: Deploi API',
	MICROSERVICE = 'Deploi: Microservice',
}

export enum LogEnvironment {
	PRODUCTION = 'Production',
	DEVELOPMENT = 'Development',
	STAGING = 'Staging',
	LOCAL = 'Local',
	DEMO = 'Demo',
}

export enum LogLevel {
	CRITICAL = 'CRITICAL',
	ERROR = 'ERROR',
	WARNING = 'WARNING',
	DEBUG = 'DEBUG',
	INFO = 'INFO',
}

export interface BasicLogInterface {
	level: LogLevel;
	correlationId?: string;
	message: string;
	logIdentifier: string; // UUID to mark log
	time: string;
	environment: LogEnvironment;
	application: LogApplicationDeploi;
	version: string;
	context?: string; // 3rd Party Int / DB / Cron / Origin of this Log
}

export function createLog(
	data: Omit<BasicLogInterface, 'time'>,
): BasicLogInterface {
	return {
		...data,
		time: new Date().toISOString(),
	};
}

export const logData = (
	logName: string,
	level: LogLevel, // 'CRITICAL' | 'ERROR' | 'WARNING' | 'DEBUG' | 'INFO',
	logIdentifier: string = '',
	stackError: { error: Error; errorInfo: ErrorInfo },
	applicantWorkerUuid: string = 'None',
) => {
	const data = {
		applicantUuid: applicantWorkerUuid,
		level: LogLevel[level],
		message: logName,
		application: LogApplicationDeploi.SCREENING_PORTAL,
		environment: capitalizeFirstLetter(process.env.REACT_APP_ENV),
		time: new Date().toISOString(),
		logIdentifier: logIdentifier,
		version: process.env.REACT_APP_VERSION
			? process.env.REACT_APP_VERSION
			: '',
		context: window.location.href,
		error: {
			stack: JSON.stringify(stackError),
		},
	};
	const log = createLog(data);
	sendLog(JSON.stringify(log));
};
